import { Outlet } from 'react-router-dom'

const ContentRoot = () => {
  return <Outlet />
}

export { ContentRoot }
